import React from 'react'
import { BANNER_TYPE, banner_type_data } from '../enum/content.enum';
import { FormControl, FormControlLabel, Radio, RadioGroup, styled } from '@mui/material';
import clsx from 'clsx';

type Props = {
    value: string;
    onClick?: (banner_type: string) => void;
    disabled?: boolean;
}

const PatternOneBox = styled('div')({
    backgroundColor: "#DDE1EB",
    width: '100%',
    height: '100%',
    borderRadius: '4px'
})
const PatternTwoBox = styled('div')({
    width: '100%',
    height: '100%',
    borderRadius: '4px',
    display: "flex",
    gap: 4
})
const PatternThreeBox = styled('div')({
    width: '100%',
    height: '100%',
    borderRadius: '4px',
    display: "flex",
    gap: 4
})
const PatternFourBox = styled('div')({
    width: '100%',
    height: '100%',
    borderRadius: '4px',
    display: "flex",
    gap: 4
})

const BannerTypeContent: React.FC<Props> = ({ onClick, disabled, value }: Props) => {
    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        onClick && onClick((event.target as HTMLInputElement).value)
    };
    return (
        <FormControl className='w-full'>
            <div className='w-full'>
                <RadioGroup
                    className='w-full'
                    aria-labelledby="demo-controlled-radio-buttons-group"
                    name="controlled-radio-buttons-group"
                    value={value}
                    onChange={handleChange}
                >
                    <div className='grid grid-cols-12 gap-4'>
                        {banner_type_data.map((list) => {
                            return (
                                <div onClick={() => !disabled && onClick?.(list.value)} key={list.value}
                                    className={clsx('w-full gap-4 hover:opacity-55 transition-all cursor-pointer flex flex-col h-full p-4 min-h-[180px] rounded-[16px] shadow-lg col-span-12 lg:col-span-6 xl:col-span-3', {
                                        'bg-[#121D39]': list.value === value
                                    })}>
                                    <span className='w-full h-full'>
                                        {list.value === BANNER_TYPE.TYPE_ONE &&
                                            <PatternOneBox>
                                            </PatternOneBox>
                                        }
                                        {list.value === BANNER_TYPE.TYPE_TWO &&
                                            <PatternTwoBox>
                                                <div className={
                                                    clsx('w-full rounded-md', {
                                                        'bg-white': list.value === value,
                                                        'bg-[#DDE1EB]': list.value !== value
                                                    })
                                                }></div>
                                                <div className={
                                                    clsx('flex-[100px] rounded-md', {
                                                        'bg-white': list.value === value,
                                                        'bg-[#DDE1EB]': list.value !== value
                                                    })
                                                }></div>
                                                <div className={
                                                    clsx('w-full h-full rounded-md flex gap-1 flex-col', {
                                                    })
                                                }>
                                                    {[1, 2].map((x) => {
                                                        return (
                                                            <span key={x} className={clsx('w-full h-full rounded-[4px]', {
                                                                'bg-white': list.value === value,
                                                                'bg-[#BFC2C9]': list.value !== value,
                                                            })}></span>
                                                        )
                                                    })}
                                                </div>
                                            </PatternTwoBox>
                                        }
                                        {list.value === BANNER_TYPE.TYPE_THREE &&
                                            <PatternThreeBox>
                                                <div className={clsx('w-full rounded-md', {
                                                    'bg-white': list.value === value,
                                                    'bg-[#BFC2C9]': list.value !== value,
                                                })}></div>
                                                <div className={clsx('flex flex-col flex-[100px] gap-1 h-full rounded-md', {
                                                })}>
                                                    {[1, 2, 3, 4].map((x) => {
                                                        return (
                                                            <span key={x} className={clsx('w-full h-full rounded-[4px]', {
                                                                'bg-white': list.value === value,
                                                                'bg-[#BFC2C9]': list.value !== value,
                                                            })}></span>
                                                        )
                                                    })}

                                                </div>
                                            </PatternThreeBox>
                                        }

                                        {list.value === BANNER_TYPE.TYPE_FOUR &&
                                            <PatternFourBox>
                                                <div className={clsx('w-full h-full border-[1px] border-dashed', {
                                                    'border-white': list.value === value,
                                                    'border-[#BFC2C9]': list.value !== value,
                                                })}>

                                                </div>
                                            </PatternFourBox>
                                        }
                                    </span>

                                    <span className='w-full'>
                                        <FormControlLabel
                                            className={clsx('', {
                                                'text-white': list.value === value
                                            })}
                                            value={list.value}
                                            control={<Radio disabled={disabled} disableRipple classes={{
                                            }} />}
                                            label={list.label}
                                        />
                                    </span>
                                </div>
                            )
                        })}
                    </div>
                </RadioGroup>
            </div>
        </FormControl>
    )
}

export default BannerTypeContent